import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import deliveryCompanyRemote from '../../../api/deliveryCompanyRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';

import TruckingCompanyModal from './truckDriverModal/TruckDriverModal';

import validation from '../../../utils/validation';
import TruckDriverDropdown from '../../common/orders/TruckDriverDropdown';
import TruckDriverData from '../../../models/TruckDriverData';

const PREFIX_PHONE_NUMBER: string = '+1';

const initialDriverData: TruckDriverData = {
  name: '',
  company: '',
  default_email: '',
  default_sms: '',
  license: '',
  plate: ''
}

interface TruckDriverContainerProps {
  receiveError: Function;
  setDriverID: Function;
  selectedDriverID: number | undefined;
  showDetails: boolean;
  hideTruckerInfo: Function;
  resetPickupTime: Function;
  changedDriver: Function;
  initialDriverID: number | undefined;
  poDriverID:  number | undefined;
  allowedToChangeTruckingCompany: boolean;
};

interface TruckDriverContainerState {
  drivers: Array<TruckDriverData>;
  name: string;
  email: string;
  company: string;
  phoneNumber: string;
  truckDriverValue: number | undefined;
  modalOpen: boolean;
  isPhoneNumber: boolean;
  driverDetails: TruckDriverData;
  isEmail: boolean;
  isValidName: boolean;
  errorName: string;
  isConfirmationOpen: boolean;
  truckDriverID: number;
  action: string;
  isValidCompany: boolean;
  errorCompany: string;
};

class TruckDriverContainer extends Component<TruckDriverContainerProps, TruckDriverContainerState> { 

  state = {
    drivers: [],
    name: '',
    email: '',
    company: '',
    phoneNumber: '',
    driverDetails: initialDriverData,
    modalOpen: false,
    isPhoneNumber: true,
    isEmail: true,
    isValidName: true,
    isValidCompany: true,
    errorCompany: 'the company can not be empty',
    errorName: 'the name can not be empty',
    truckDriverValue: undefined,
    isConfirmationOpen: false,
    truckDriverID: -1,
    action: ''
  };

  componentDidMount() {

    this.setState({ truckDriverValue: this.props.selectedDriverID });

    deliveryCompanyRemote.getTruckDrivers().then((resp: ApiResponse<Array<TruckDriverData>>) => {

      const drivers: Array<TruckDriverData> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (drivers) {
        this.setState({ drivers });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  componentDidUpdate(prevProps: TruckDriverContainerProps) {

    if (prevProps.selectedDriverID !== this.props.selectedDriverID) {
      this.setState({ truckDriverValue: this.props.selectedDriverID });
    }
  }

  handleOpenModal = (): void => {

    this.setState({ modalOpen: true });
  };

  handleCloseModal = (): void => {
    this.setState({
      name: '',
      email: '',
      phoneNumber: '',
      modalOpen: false,
      isPhoneNumber: true,
      isEmail: true,
      isValidName: true,
      errorName: 'the name can not be empty'
    });
  };

  onValidationName = (): void => {

    if (this.state.name === '') {
      this.setState({
        isValidName: false,
        errorName: 'the name can not be empty'
      });
    } else {

      const isNameExist: boolean = this.state.drivers.some((item: TruckDriverData) => item.name === this.state.name);

      if (isNameExist) {
        this.setState({
          isValidName: false,
          errorName: 'the name exist'
        });
      } else {
        this.setState({
          isValidName: true,
          errorName: ''
        });
      };
    };
  };

  onValidationEmail = (): void => {

    if (this.state.email !== '') {

      const isEmail: boolean = validation.validateEmail(this.state.email);
      
      this.setState({ isEmail })
    } else {
      this.setState({ isEmail: true });
    };
  };

  onValidationCompany = (): void => {

    if (this.state.company === '') {

      this.setState({
        isValidCompany: false,
        errorCompany: 'the company can not be empty'
      });
    } else {
      this.setState({
        isValidName: true,
        errorName: ''
      });
    };
  };

  onValidationPhoneNumber = (): void => {

    if (this.state.phoneNumber !== '') {
  
      const isPhoneNumber: boolean = validation.validatePhoneNumber(this.state.phoneNumber);

      this.setState({ isPhoneNumber });
    } else {
      this.setState({ isPhoneNumber: true });
    };
  };

  handleChange = (propertyName: string, event: any)  => {

    const value: string = event.target.value;
    const driverDetails: TruckDriverData = {...this.state.driverDetails};

    switch (propertyName) {
      case 'name': 
        this.setState({ name: value }); 
        break;
      case 'email': 
        this.setState({ email: value }); 
        break;
      case 'phoneNumber':
       this.setState({ phoneNumber: value }); 
       break;
      case 'company': 
        this.setState({ company: value }); 
        break;
      case 'license': 
        driverDetails.license = value;
        this.setState({ driverDetails });  
        break;
      case 'plate':
        driverDetails.plate = value; 
        this.setState({ driverDetails }); 
       break;
      default: return;
    };
  };

  handleSubmit = (): void => {

    const phoneNumber: string = this.state.phoneNumber;
    const driverData: TruckDriverData = {...this.state.driverDetails};
    driverData.default_sms = (phoneNumber ? PREFIX_PHONE_NUMBER : '') + phoneNumber;
    driverData.name = this.state.name;
    driverData.default_email = this.state.email;
    driverData.company = this.state.company;

    deliveryCompanyRemote.addNewTruckDriver(driverData).then((resp: ApiResponse<Array<TruckDriverData>>) => {

      const drivers: Array<TruckDriverData> | undefined = resp.result;
      const error: ResponseError| undefined = resp.error;

      if (drivers) {

        const truckDriver : TruckDriverData | undefined = drivers.find(x=> x.name === this.state.name);

        if (truckDriver) {

          const truckDriverValue: number | undefined = truckDriver.id;

          this.setState({ truckDriverValue });
          this.props.setDriverID(truckDriverValue);
        };
        
        this.setState({ drivers });
        this.handleCloseModal();
      };

      if (error) {
        this.props.receiveError(error);
      }; 
    });
  };

  handleChangeDeliveryCompany = (event: any): void => { 

    const truckDriverValue: number = Number(this.state.truckDriverID);

    this.props.changedDriver(truckDriverValue);
    this.setState({ truckDriverValue });
  };

  openConfirmation = (event: any): void => {

    const truckDriverValue: number = Number(event.value);

    this.setState({ action: 'openConfirmation', truckDriverID: truckDriverValue });

    if (this.props.poDriverID !== null && this.props.initialDriverID !== truckDriverValue) {

      this.setState({ truckDriverValue: truckDriverValue });
      this.props.changedDriver(truckDriverValue);
      this.props.setDriverID(truckDriverValue);
    }
    else {

      this.setState({ truckDriverValue: truckDriverValue });
      this.props.changedDriver(truckDriverValue);
    }
  }

  closeConfirmation = (): void => {

    this.setState({ isConfirmationOpen: false });
  }

  switchToAction = (): void => {

    const action: string = this.state.action;

    switch (action) {

      case 'openConfirmation': this.handleChangeDeliveryCompany(null); break;
      case 'handleOpenModal': this.setState({ modalOpen: true }); break;
      default: break;
    }

    this.props.resetPickupTime();
    this.closeConfirmation();
  }

  render() {
    return (
      <Fragment>
        <TruckDriverDropdown 
          openModal={ this.handleOpenModal }
          items={ this.state.drivers }
          value={ this.state.truckDriverValue }
          onChange={ this.openConfirmation }
          allowedToChange={ this.props.allowedToChangeTruckingCompany }
          labelText=''
          type="truckingCompany"
        />
      
        { this.state.modalOpen && 
          <TruckingCompanyModal
            name={ this.state.name }
            email={ this.state.email }
            truckDriver={ this.state.driverDetails }
            errorCompany={ this.state.errorCompany }
            isValidCompany={ this.state.isValidCompany }
            onValidationCompany={ this.onValidationCompany }
            company={ this.state.company }
            phoneNumber={ this.state.phoneNumber }
            modalOpen={ this.state.modalOpen }
            prefixPhoneNumber={ PREFIX_PHONE_NUMBER }
            isPhoneNumber={ this.state.isPhoneNumber }
            isEmail={ this.state.isEmail }
            isValidName={ this.state.isValidName }
            errorName={ this.state.errorName }
            handleCloseModal={ this.handleCloseModal }
            onValidationName={ this.onValidationName }
            onValidationEmail={ this.onValidationEmail }
            onValidationPhoneNumber={ this.onValidationPhoneNumber }
            handleChange={ this.handleChange }
            handleSubmit={ this.handleSubmit }
          />
        }
      </Fragment>
    );
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(null, mapDispatchToProps)(TruckDriverContainer);
